<template>
  <div class="right-body" id="shareList">
    <div id="rightBo"></div>
    <div class="shares-up">
      <div id="navigation" v-show="pathJson.length>0">
          <div class="navigation-path">
            <table>
              <tr>
                <div class="icon-util my-share-icon home-icon-position my-share-click" :class="myShare?'my-share-click':'save-share-click'" @click="toHomePage()"></div>
                <span>
                  <td class="name-desc-one name-desc" v-show="myShare" @click="toHomePage()">{{$t('language.shares.myShares')}}</td>
                  <td class="name-desc-one name-desc" v-show="saveShare" @click="toHomePage()">{{$t('language.shares.savedShares')}}</td>
                </span>
                <td class="icon-util separate_icon separate-icon-position"></td>
                <div style="float:left;line-height:18Px;">
                <span :key="index" v-for="(path,index) in pathJson">
                  <td class="icon-util separate_icon separate-icon-position" :id="index" v-if="index"></td>
                  <td :title="path.name" v-bind:class="{'text-bold':index==pathJson.length-1,'name-desc-one':index==0,
                  'name-desc':pathJson.length!=0&&index!=pathJson.length-1&&pathJson.length>1&&path.id!='addEllipsis','add-Ellipsis':path.id=='addEllipsis'}"
                  @click="comeBackFile($event,path,index)">{{path.fileName|ellipsisNavi}}</td>
                </span>
                </div>
              </tr>
            </table>
          </div>
      </div>
      <div class="share-all" v-show="!pathJson.length>0">
        <div class="my-share" @click="clickTabTitle(0)" ref="myShareTab">
          <div class="icon-util my-share-icon my-share-icon-position" :class="myShare?'my-share-click':'my-share-icon'"></div>
          <span :class="myShare?'share-color-click':'share-color'">{{$t('language.shares.myShares')}}</span>
        </div>
        <div class="save-shares" @click="clickTabTitle(1)" ref="saveShareTab">
          <div class="icon-util save-share-icon-position" :class="saveShare?'save-share-click':'save-share-icon'"></div>
          <span :class="saveShare?'share-color-click':'share-color'">{{$t('language.shares.savedShares')}}</span>
        </div>
        <div class="share-tab-bar" ref="shareTabBar" :style="{width:shareTabBarWidth,transform:'translateX('+shareTabBarTransform+')'}"></div>
      </div>
      <!-- 左上菜单键 -->
        <div class="menu-bar" :class="[searchResultShow?'menu-bar-search':'']" ref="menuList">
            <div class="menu-button button-border-all" v-if="selectItemArr.length" ref="menuButtonList">
                <div v-show="myShare" style="position:relative;">
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('cancel')?'':'button-border']"  @click="cancelShareDialgOpen()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('cancel')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(1)}">
                                <div class="cancel icon-position more-white-position"></div>
                                <div class="share-operating">{{$t('language.common.cancel')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('edit_share')?'':'button-border']"  @click="shareDialgOpen()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('edit_share')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(2)}">
                              <div class="edit-share icon-position more-white-position"></div>
                              <div class="share-operating">{{$t('language.common.editShare')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('download')?'':'button-border']"  @click="download" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('download')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(3)}">
                              <div class="down-load icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.download')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('preview')?'':'button-border']"  @click="previewPageShow" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('preview')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(4)}">
                              <div class="preview icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.preview')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('to_source')?'':'button-border']"  @click="toSource()" :style="{width:getWidth()}" v-show="showToSource('to_source')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(5)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toSource')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('to_share')?'':'button-border']"  @click="goTo()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('to_share')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(6)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button button-border" @click="topRightMenuShow()" :style="{width:getWidth()}" v-clickoutside="topRightMenuShowClose" v-show="judgeShowLeftMenu('more')&&showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(7)}">
                              <div class="more more-position more-white-position"></div>
                              <div class="share-operating">{{$t('language.common.more')}}</div>
                            </div>
                        </div>
                        <div class="more-items-choose" v-show="moreChooseShow" :style="{width:getTextWidth(12)}">
                            <div class="more-item-choose" @click="previewPageShow()" v-show="judgeShowLeftMenu('more_preview')">
                                <div class="preview item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.preview')}}</div>
                            </div>
                            <div class="more-item-choose" @click="toSource()" v-show="showToSource('more_to_source')">
                                <div class="copy-to item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.toSource')}}</div>
                            </div>
                            <div class="more-item-choose" @click="goTo()" v-show="judgeShowLeftMenu('more_to_share')">
                                <div class="copy-to item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_preview')?'':'button-border']"  @click="previewPageShow()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_preview')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(4)}">
                              <div class="preview icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.preview')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_to_source')?'':'button-border']"  @click="toSource()" :style="{width:getWidth()}" v-show="showToSource('more_to_source')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(5)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toSource')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_to_share')?'':'button-border']"  @click="goTo()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_to_share')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(6)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                </div>
                <div v-show="saveShare">
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('copy_to')?'':'button-border']" @click="copyToDialogShow()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('copy_to')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(8)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.copyTo')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('download')?'':'button-border']" @click="download()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('download')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(3)}">
                              <div class="down-load icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.download')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('preview')?'':'button-border']" @click="previewPageShow()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('preview')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(4)}">
                              <div class="preview icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.preview')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('copy')?'':'button-border']" @click="copyFile()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('copy')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(10)}">
                              <div class="copy icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.copy')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('remove')?'':'button-border']" @click="cancelShare()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('remove')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(9)}">
                              <div class="remove icon-position more-white-position"></div>
                              <div class="share-operating">{{$t('language.leftBanner.remove')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('copy_link')?'':'button-border']" @click="copy()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('copy_link')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(11)}">
                              <div class="copy-link icon-position more-white-position"></div>
                              <div class="share-operating">{{$t('language.common.copyLink')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('to_share')?'':'button-border']" @click="goTo()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('to_share')">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(6)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button button-border" @click="topRightMenuShow()" :style="{width:getWidth()}" v-clickoutside="topRightMenuShowClose" v-show="judgeShowLeftMenu('more')&&showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(7)}">
                              <div class="more more-position more-white-position"></div>
                              <div class="share-operating">{{$t('language.common.more')}}</div>
                            </div>
                        </div>
                        <div class="more-items-choose" v-show="moreChooseShow" :style="{width:getTextWidth(12)}">
                            <div class="more-item-choose" @click="previewPageShow()" v-show="judgeShowLeftMenu('more_preview')">
                                <div class="preview item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.preview')}}</div>
                            </div>
                            <div class="more-item-choose" @click="copyFile()" v-show="judgeShowLeftMenu('more_copy')">
                                <div class="copy item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.copy')}}</div>
                            </div>
                            <div class="more-item-choose" @click="copy" v-show="judgeShowLeftMenu('more_copy_link')">
                                <div class="copy-link item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.copyLink')}}</div>
                            </div>
                            <div class="more-item-choose" @click="goTo()" v-show="judgeShowLeftMenu('more_to_share')">
                                <div class="copy-to item-position preview-position"></div>
                                <div class="menu-txt">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_preview')?'':'button-border']"  @click="previewPageShow()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_preview')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(4)}">
                              <div class="preview icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.preview')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_copy')?'':'button-border']"  @click="copyFile()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_copy')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(10)}">
                              <div class="copy icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.copy')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_copy_link')?'':'button-border']"  @click="copy()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_copy_link')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(11)}">
                              <div class="copy-link icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.copyLink')}}</div>
                            </div>
                        </div>
                    </button>
                    <button class="single-button" :class="[judgeShowLeftMenuBorder('more_to_share')?'':'button-border']"  @click="goTo()" :style="{width:getWidth()}" v-show="judgeShowLeftMenu('more_to_share')&&!showMore">
                        <div class="button-content">
                            <div class="button-center-position" :style="{width:getTextWidth(6)}">
                              <div class="copy-to icon-position more-white-position"></div>
                              <div class="share-operating ">{{$t('language.common.toShare')}}</div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
          <div class="menu-button" v-if="selectItemArr.length<1">
            <div>
              <span v-show="myShare" class="no-manage-share">{{$t('language.share.noManageMyShare')}}</span>
              <span v-show="saveShare" class="no-manage-share">{{$t('language.share.noManageSavedShare')}}</span>
            </div>
          </div>
          <div class="share-icons" onselectstart="return false">
                <div :data-title="$t('language.cloudExploer.reFresh')" v-if="!searchResultShow" class="icon-util refresh cloud-exploer-refresh refresh-position" @click="refresh()"></div>
                <div v-show="listShow" :data-title="$t('language.cloudExploer.grid')" class="list refresh-position" @click="gridSwitch()"></div>
                <div v-show="!listShow" :data-title="$t('language.cloudExploer.pageList')" class="icon-util grid refresh-position" @click="gridSwitch()"></div>
            </div>
        </div>


    </div>
    <!--    <div class="shares-up">-->
    <!--      工具栏-->
    <!--    </div>-->
    <div class="share-body" >
      <div class="my-shares-table" v-if="listShow" >
        <div >
          <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
            <tr class="table-th">
              <td class="cloud-td-one-share" @click="changeUpDownOrder(0)" :style="myShare?'':'width:52%'">
                <div class="tr-check-box" @click.stop="selectAll()">
                  <div class="icon-util icon-tr-position" :class="this.isAllSelected?'check-small':'nocheck-small'"></div>
                </div>
                <span class="th-span">{{$t('language.common.fileName')}}</span>
                <div v-if="index==0" class="icon-util file-narrow-position narrow-position" :class="upShow?'file-up-narrow':'file-down-narrow'" ></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(3)" :style="myShare?'':'width:16%'">
                <span>{{$t('language.common.type')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==3" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(1)" :style="myShare?'':'width:16%'">
                <span>{{$t('language.common.size')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==1" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(2)" :style="myShare?'':'width:16%'">
                <span v-if="pathJson.length<1" >{{$t('language.shares.sharedOn')}}</span>
                <span v-else >{{$t('language.common.dateModified')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==2" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" v-if="myShare" style="text-align: center">{{$t('language.shares.allowedTo')}}</td>
              <!-- <td class="td-others" v-if="saveShare">{{$t('language.shares.allowedTo')}}</td> -->
            </tr>
          </table>
        </div>
        <div id="shareBox" v-loading="isLoading">
           <el-scrollbar style='height:100%;' v-if="nowTableData.length>0">
          <table border="0" v-infinite-scroll="loadTableData" infinite-scroll-delay=0 cellpadding="0" cellspacing="0" style="width:100%;">
            <tr class="table-tr" style="line-height: 25px;"
                :class="[selectItemArr.includes(item)?'tr-back-ground':'',tableHoverItem===item?'table-tr-hover':'', item.isCancel==='yes'?'disable-tr':'']"
                :key="index" v-for="(item,index) in nowTableData"
                @mouseout="tableHoverItem=null" @mouseover="tableHoverItem=item" @dblclick.stop="dblclickShare(item)"
                @contextmenu.prevent="shareRightMenuOpen($event, item)" @click="addTableCheck(item,true)">
              <td class="cloud-td-one-share" :style="myShare?'':'width:52%'">
                <div class="tr-check-box" @click.stop="addTableCheck(item,false)">
                  <div class="icon-util icon-tr-position" :class="selectItemArr.includes(item)?'check-small':'nocheck-small'"></div>
                </div>
                <div class="small-file share-name-position share-file-position" :class="getFileImg(item)"
                     style="margin-top: 8px"></div>
                <!--                <div :title="item.fileName" class="share-name-position file-name">{{item.fileName}}</div>-->
                <div class="share-name-position file-name" @dblclick.stop="dblclickShare(item)">
                  <div class="name-edit-div-share" :class="{'disable-tr':item.isCancel==='yes'}" :title="item.fileName">{{item.fileName|ellipsis}}
                  </div>
                </div>
              </td>
              <td class="cloud-td-two" :style="myShare?'':'width:16%'">{{getItemType(item.type)}}</td>
              <td class="cloud-td-two" :style="myShare?'':'width:16%'">{{item.fileSize|formatByte}}</td>
              <td class="cloud-td-two" :style="myShare?'':'width:16%'">{{item.createTime|transferTime}}</td>
              <td class="cloud-td-two" v-if="myShare" :style="myShare?'':'width:16%'">
                <MySwitch v-show="item.fileType==='folder'&&item.id&&item.pathJson&&item.isUpload!=undefined" v-model="item.isUpload" :shareId="item.id"></MySwitch>
              </td>
              <!--td class="td-others" v-if="saveShare">{{getItemIsupload(item.isUpload)}}</td-->
            </tr>
          </table>
          </el-scrollbar>
          <div v-else class="list-null">
            <div v-if="myShare">
              <p class="list-null-title">{{$t('language.shares.shareNull')}}</p>
              <p class="list-null-tips share-color">{{$t('language.shares.shareNullTips')}}</p>
            </div>
            <div v-else>
              <p class="list-null-title">{{$t('language.shares.savedShareNull')}}</p>
              <p class="list-null-tips share-color">{{$t('language.shares.savedShareNullTips')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else  class="grid-list" >
        <div >
          <table border="0" cellpadding="0" cellspacing="0" style="width:100%;">
            <tr class="table-th">
              <td class="cloud-td-one-share" @click="changeUpDownOrder(0)" :style="myShare?'':'width:52%'">
                <div class="tr-check-box" @click.stop="selectAll()">
                  <div class="icon-util icon-tr-position" :class="this.isAllSelected?'check-small':'nocheck-small'"></div>
                </div>
                <span class="th-span">{{$t('language.common.fileName')}}</span>
                <div v-if="index==0" class="icon-util file-narrow-position narrow-position" :class="upShow?'file-up-narrow':'file-down-narrow'" ></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(3)" :style="myShare?'':'width:16%'">
                <span>{{$t('language.common.type')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==3" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(1)" :style="myShare?'':'width:16%'">
                <span>{{$t('language.common.size')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==1" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" @click="changeUpDownOrder(2)" :style="myShare?'':'width:16%'">
                <span v-if="pathJson.length<1" >{{$t('language.shares.sharedOn')}}</span>
                <span v-else >{{$t('language.common.dateModified')}}</span>
                <div class="icon-util narrow-position-two" v-if="index==2" :class="upShow?'file-up-narrow':'file-down-narrow'"></div>
              </td>
              <td class="cloud-td-two" v-if="myShare" style="text-align: center">{{$t('language.shares.allowedTo')}}</td>
              <!-- <td class="td-others" v-if="saveShare">{{$t('language.shares.allowedTo')}}</td> -->
            </tr>
          </table>
        </div>
        <!--fileGrid和cloud_explore中id冲突-->
        <div id="fileGrid" v-loading="isLoading">
          <el-scrollbar style='height:100%;' v-if="nowTableData.length>0">
          <div class="grid-lattice" :key="index" v-for="(item,index) in nowTableData" v-infinite-scroll="loadTableData" infinite-scroll-delay=0
               @contextmenu.prevent="shareRightMenuOpen($event, item)" @click="dblclickShare(item),rightMenuShow = false;"
               @mouseover="gridHoverIndex=index,tableHoverItem=item" @mouseout="gridHoverIndex=-1">
            <div class="grid-all"
                 :class="[gridHoverIndex===index?'grid-hover':'']">
              <div style="height:25Px;width:25Px;" @click.stop="addTableCheck(item,false)">
                  <div class="icon-util grid-icon-positon" :class="selectItemArr.includes(item)?'check-small':'nocheck-small'"></div>
              </div>
              <div class="grid-position">
                  <div class="large-file-type " :class="item.dir?'large-'+matchfolderType(item.docType)+' large-folder-position':'large-'+matchfileType(item.fileName)"></div>
              </div>
              <div class="grid-name" @click.stop="" @mouseover.stop="gridHoverIndex=-1">
                <span :title="item.fileName" ref="gridName" class="grid-name-children" :class="{'disable-tr':item.isCancel==='yes'}">{{item.fileName|ellipsisOther}}</span>
                <div class="grid-outclass" ref="gridInputName">
                  <input class="grid-edit-input" v-model="item.inputValue" @focus="onfocusEvent" @blur="submitName($event,item,index)" />
                  <div class="grid_edit_icon">
                    <div class="icon-util grid-name-sure" @click.stop="submitName($event,item,index)"></div>
                    <div class="icon-util grid-name-cancel" @mousedown.stop="cancelEditName($event,item,index)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </el-scrollbar>
          <div v-if="nowTableData.length==0&&!isLoading" class="list-null">
            <div v-if="myShare">
              <p class="list-null-title">{{$t('language.shares.shareNull')}}</p>
              <p class="list-null-tips share-color">{{$t('language.shares.shareNullTips')}}</p>
            </div>
            <div v-else>
              <p class="list-null-title">{{$t('language.shares.savedShareNull')}}</p>
              <p class="list-null-tips share-color">{{$t('language.shares.savedShareNullTips')}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 右键某个item显示菜单 整个大菜单-->
      <div class="right-menus-choose" v-if="shareRightMenuShow" id="shareRightMenu" v-clickoutside="shareRightMenuClose"
           @contextmenu.prevent>
        <div v-show="myShare">
          <div v-show="judgeShowRightMenu('cancel')" class="more-item-choose" @click.stop="cancelShareDialgOpen()">
            <div class="item-position cancel preview-position"></div>
            <div>{{$t('language.common.cancel')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('edit_share')" class="more-item-choose" @click.stop="shareDialgOpen()">
            <div class="item-position edit-share preview-position"></div>
            <div>{{$t('language.common.editShare')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('download')" class="more-item-choose" @click.stop="download">
            <div class="item-position down-load preview-position"></div>
            <div>{{$t('language.common.download')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('preview')" class="more-item-choose" @click.stop="previewPageShow()">
            <div class="item-position preview preview-position"></div>
            <div class="menu-txt">{{$t('language.common.preview')}}</div>
          </div>
          <div v-show="showToSource('to_source')" class="more-item-choose"  @click.stop="toSource()">
            <div class="item-position copy-to preview-position"></div>
            <div class="menu-txt">{{$t('language.common.toSource')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('to_share')" class="more-item-choose"  @click.stop="goTo()">
            <div class="item-position copy-to preview-position"></div>
            <div class="menu-txt">{{$t('language.common.toShare')}}</div>
          </div>
        </div>
        <div v-show="saveShare">
          <div v-show="judgeShowRightMenu('copy_to')" class="more-item-choose" @click.stop="copyToDialogShow()">
            <div class="item-position copy-to preview-position"></div>
            <div>{{$t('language.common.copyTo')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('download')" class="more-item-choose" @click.stop="download">
            <div class="item-position down-load preview-position"></div>
            <div>{{$t('language.common.download')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('preview')" class="more-item-choose" @click.stop="previewPageShow()">
            <div class="item-position preview preview-position"></div>
            <div class="menu-txt">{{$t('language.common.preview')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('copy')" class="more-item-choose"  @click.stop="copyFile">
            <div class="item-position copy preview-position"></div>
            <div class="menu-txt">{{$t('language.common.copy')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('remove')" class="more-item-choose" @click.stop="cancelShare()">
            <div class="item-position remove preview-position"></div>
            <div>{{$t('language.leftBanner.remove')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('copy_link')" class="more-item-choose"  @click.stop="copy">
            <div class="item-position copy-link preview-position" ></div>
            <div class="menu-txt">{{$t('language.common.copyLink')}}</div>
          </div>
          <div v-show="judgeShowRightMenu('to_share')" class="more-item-choose"  @click.stop="goTo()">
            <div class="item-position copy-to preview-position"></div>
            <div class="menu-txt">{{$t('language.common.toShare')}}</div>
          </div>
        </div>
        <!-- more-item-choose某一项菜单 每一项对应一个点击事件 -->
        <!--div v-show="this.selectItemArr.length === 1" class="more-item-choose" @click.stop="goTo">
          <div class="icon-util item-position share"></div>
          <div>跳转到url</div>
        </div>
        <div v-show="this.selectItemArr.length === 1" class="more-item-choose" @click.stop="copy">
          <div class="icon-util item-position share"></div>
          <div>复制url</div>
        </div-->


      </div>
      <div class="selectInfo-footer">
            <div class="select-Info" v-show="myShare">{{selectItemArr.length}}/{{shareTableData.length}} {{$t('language.common.itemsSelected')}} </div>
            <div class="select-Info" v-show="saveShare">{{selectItemArr.length}}/{{savedShareTableData.length}} {{$t('language.common.itemsSelected')}} </div>
            <div class="select-Info" v-show="myShare">{{selectItemArr|getAllBytes|formatByte}}/{{shareTableData|getAllBytes|formatByte}}</div>
            <div class="select-Info" v-show="saveShare">{{selectItemArr|getAllBytes|formatByte}}/{{savedShareTableData|getAllBytes|formatByte}}</div>
            <div class="icon scaling-open scaling-open-position" v-show="snapTaskIconShow" @click="snapTasksOpen()">
                <snapTaskDialog ref="snapTaskDialog" @cancel='cancelUpload($event)'></snapTaskDialog>
            </div>
      </div>
    </div>
    <shareDialog ref="shareDialog"></shareDialog>
    <cancelShareDialog ref="cancelShareDialog"></cancelShareDialog>
    <copyToDialog ref="copyToDialog"></copyToDialog>
    <fileExistDialog ref="fileExistDialog"></fileExistDialog>
    <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    <detailedProgrssDialog ref="detailedProgrss"></detailedProgrssDialog>
    <cancelAllDialog ref="cancelAllDialog"></cancelAllDialog>
    <retryFailedDialog ref="retryFailedDialog"></retryFailedDialog>
    <remindBindEmailDialog ref="remindBindEmailDialog"></remindBindEmailDialog>
  </div>
</template>

<script>
  import '@/assets/css/common_util.css';
  import '@/assets/css/table.css';
  import commonstate from '@/js/constant.js';
  import commonUtils from "@/js/workspace/common_util.js";
    import GaUtil from "@/js/workspace/google_analytics_util.js";
  import MySwitch from "@/components/common/input/switch";
  import shareDialog from "@/components/popup/cloud_exploer_popups/share_popup";
  import cancelShareDialog from '@/components/popup/cloud_exploer_popups/cancel_share_popup.vue';
  import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
  import copyToDialog from "@/components/popup/cloud_exploer_popups/copy_to_popup";
  import fileExistDialog from '@/components/popup/cloud_exploer_popups/file_exist_popup.vue';
  import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
  import snapTaskDialog from "@/components/popup/cloud_exploer_popups/snap_task_popup";
  import detailedProgrssDialog from '@/components/popup/cloud_exploer_popups/detailed_progress_popup';
  import cancelAllDialog from '@/components/popup/cloud_exploer_popups/cancel_all_popup.vue';
  import retryFailedDialog from "@/components/popup/cloud_exploer_popups/retry_detailProgress_failed_popup";
  import remindBindEmailDialog from "@/components/popup/personal_center_popups/remind_bind_email_popup";
  export default {
    components: {
      MySwitch,
      shareDialog,
      cancelShareDialog,
      copyToDialog,
      fileExistDialog,
      upgradeNewDialog,
      snapTaskDialog,
      detailedProgrssDialog,
      cancelAllDialog,
      retryFailedDialog,
      remindBindEmailDialog
    },
    data: () => ({
      isLoading: true,
      listShow: true,
      myShare: true,
      saveShare: false,
      gridHoverIndex: -1,
      // start 保存的分享和我的分享
      shareTableData: [],
      savedShareTableData: [],
      // end 保存的分享和我的分享
      selectItemArr: [], //保存用户分享的数据
      isAllSelected: false,
      tableHoverItem: null,
      shareRightMenuShow: false, //控制右键菜单显示
      pathJson: [],
      searchResultShow: false,
      moreChooseShow: false,
      upShow: true,
      index: 0,
      sharePathJson: [],
      isCancelNum: 0,
      //左上角和右键菜单显示权限集合
      showLeftMenuArr: [],
      showRightMenuArr: [],
      snapTaskIconShow: false,
      shareDataArr:[],
      isflage: true,
      retryItems: [],
      shareTabBarWidth: "",
      shareTabBarTransform: "",
      showMore: false,//是否展开左上角菜单More选项
      nowTableData:[],//防止页面数据过多，只能让其渲染的数据
      count:200,//初始化加载数据刚开始为200条
    }),
    mounted(){
      let that = this
      this.$nextTick(()=>{
        window.addEventListener('resize', () => { //监听浏览器窗口大小改变
          //浏览器变化执行动作
          if(that.selectItemArr.length>0){
            that.showMore=false;
            this.$nextTick(()=>{
              that.checkBoxWidth();
            });
          }
        });
      })
      //初始化临时任务数据
      commonUtils.mountedDetailData(that);
    },
    created() {
      // 页面加载时请求tableShares数据
      if(this.$route.query.fileId){
        this.reacquireData()
      }else{
        this.$nextTick(()=>{
          switch (this.$store.state.sharesType) {
            case 0:
              this.toMyShare()
              break;
            case 1:
              this.toSaveShare()
              break;
            default:
              this.toMyShare()
              break;
          }
        });
      }
       //判断是列表显示还是平铺显示
        this.getListShow();
    },
    watch: {
      // 全选的checkbox和下方元素的checkbox互相关联
      isAllSelected(val) {
        if (val) {
          this.selectItemArr = this.myShare ? [...this.shareTableData] : [...this.savedShareTableData]
        }
      },
      selectItemArr(val) {
        let compareData = this.myShare ? this.shareTableData : this.savedShareTableData
        if (val.length && compareData.length) {
          this.isAllSelected = val.length === compareData.length;
        }else{
          this.isAllSelected = false;
        }
        //savedShare需要判断isCancel
        if(this.saveShare){
          this.isCancelNum = this.selectItemArr.filter((v) => {
            return v.isCancel === 'yes'
          }).length
        }
        //判断显示的左上角菜单和右键菜单
        this.judgeShowMenu()
        //清空shareDataArr
        this.shareDataArr = [];
      },

      '$store.state.haveNewSnapData': function (newValue, oldValue) {
      let that = this;
      //触发事件后，判断是否获取进度
      if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度
        commonUtils.runDetailProgressData(that);
      }
    },
    //监听缓存中右侧待执行临时任务列表数据
    '$store.state.retryItems': function () {
      this.$refs.snapTaskDialog.items = Object.assign([], this.$store.state.retryItems);
      if (this.$store.state.retryItems.length > 200) {
        this.$store.state.retryItems.splice(201, this.$store.state.retryItems.length + 1);
        this.$toast({
          text: this.$t('language.cloudExploer.simultaneous'),
          type: 'fail',
          idValue: "rightBo"
        });
      }
      this.retryItems = this.$refs.snapTaskDialog.items;
    },
     //监听右侧待执行临时任务列表+上传列表总和数据
    retryItems: function (newValue, oldValue) {
      let that = this;
      if (!newValue.length) {
        this.$store.commit("setSourceItems", []);
        this.selectItemArr = [];
      }
      //任务执行列表执行操作，包括刷新后界面仍有任务
      if (oldValue.length == 0) {
        this.$nextTick(function () {
          if (that.$store.state.loadFlag) {
            commonUtils.runDetailProgressData(that);
            that.$store.state.loadFlag = false;
          }
        });
      }
    },
    //监听临时任务并根据状态将数据放在不同的tab页面
    '$store.state.detailedProgrssData': function (newValue, oldValue) {
      this.$refs.detailedProgrss.$refs.tab1.taskDatas = newValue;
    },
     //监听上传列表数据
    '$store.state.uploadArr': function (newVale, oldValue) {
      let snapData = Object.assign([], this.$store.state.retryItems);
      let uploadArr = Object.assign([], this.$store.state.uploadArr);
      this.$refs.snapTaskDialog.items = snapData.concat(uploadArr);
    },
    showLeftMenuArr: function (newValue, oldValue) {
        if(newValue&&newValue.length&&this.selectItemArr.length){
          this.showMore=false;
          this.$nextTick(()=>{
            this.checkBoxWidth();
          });
        }
      },
      //监听界面数据变化
    shareTableData(newValue, oldValue){
      if(newValue.length>=200){
        this.nowTableData=newValue.slice(0,200);
      }else{
        this.nowTableData=newValue;
      }
    },
    savedShareTableData(newValue, oldValue){
      if(newValue.length>=200){
        this.nowTableData=newValue.slice(0,200);
      }else{
        this.nowTableData=newValue;
      }
    },
    pathJson(newValue, oldValue){
      this.count=200;
    }
    },
    methods: {
      loadTableData(){
          this.count += 200;
          if(this.myShare){
            if(this.count<this.shareTableData.length){
            this.nowTableData=this.shareTableData.slice(0,this.count);
            }else{
             this.nowTableData=this.shareTableData.slice(0,this.shareTableData.length);
            }
          }else if(this.saveShare){
            if(this.count<this.savedShareTableData.length){
              this.nowTableData=this.savedShareTableData.slice(0,this.count);
            }else{
              this.nowTableData=this.savedShareTableData.slice(0,this.savedShareTableData.length);
            }
          }
        },
      copy(){
        let data = this.selectItemArr[0].url
        let oInput = document.createElement('input');
        oInput.value = data;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$toast({
          text: this.$t('language.popup.cloudExploerPopup.linkCopySuccessful'),
          type: 'success',
          idValue: "shareBox",
        });
        oInput.remove()
      },
      download() {
        this.shareRightMenuShow = false
        this.moreChooseShow = false
        let v = this.selectItemArr[0];
        const that = this;
        if(this.myShare){
          let downloadData = {ud: commonstate.user.id, dd: v.tokenId, id: v.fileId, n: v.fileName}
          if(v.webUrl){
            downloadData.webUrl = v.webUrl;
          }
          this.Utils.doFilesRequest('download.createSession', downloadData).then(res => {
            if (res.download_id) {
              let e = commonUtils.createDownloadForm(res.download_id);
              GaUtil.shareDownload(that);
              e.submit();
            }else if((res.message+"").indexOf("404")!==-1){
              this.$toast({
                text: this.$t('language.sharesPage.errorShare404'),
                type: 'fail',
                idValue: "shareBox"
              });
            } else {
              this.$toast({
                  text: this.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
            }
          })
        }else if(this.saveShare){//保存的分享需要加密id
          let downloadData = {
            ud: commonstate.user.id,
            dd: v.tokenId,
            id: v.cryptId, //加密id
            n: v.fileName,
            shareUserId: this.pathJson[0]?this.pathJson[0].userId:this.selectItemArr[0].userId,
            shareId: this.pathJson[0]?this.pathJson[0].id:this.selectItemArr[0].id,
            shareUpdateData:this.pathJson[0]?this.pathJson[0].updateTime:this.selectItemArr[0].updateTime
          }
          if(this.selectItemArr[0].webUrl){
            downloadData.webUrl = this.selectItemArr[0].webUrl;
          }
          this.Utils.doShareFileRequest('download.createSession', downloadData).then(res => {
            if (res.download_id) {
              let e = commonUtils.createDownloadForm(res.download_id);
              e.submit();
            }else if((res.message+"").indexOf("404")!==-1){
              this.$toast({
                text: this.$t('language.sharesPage.errorShare404'),
                type: 'fail',
                idValue: "shareBox"
              });
            }else if("unknownError"===res.reason){
                this.$toast({
                  text: this.$t('language.share.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
            } else {
              this.$toast({
                  text: this.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
            }
          })
        }
      },
      cancelShare() {
        this.shareRightMenuShow = false
        this.moreChooseShow = false
        let res_arr = []
        // 如果在我的分享界面调用取消分享，如果在保存的分享界面调用删除保存的分享
        this.selectItemArr.forEach(v => {
          if(v.isTransfers){
            let itfc = this.myShare ? 'cancel_share_transfers' : 'delete_saved_share_transfers'
            res_arr.push(this.Utils.doShareRequest(itfc, {id: v.id, ud: commonstate.user.id}))
          }else{
            let itfc = this.myShare ? 'cancel_share' : 'delete_saved_share'
            res_arr.push(this.Utils.doShareRequest(itfc, {shareId: v.id, ud: commonstate.user.id}))
          }
        })
        Promise.all(res_arr).then(res => {
          // 全部删除成功后重新请求数据
          this.isAllSelected = false
          this.$refs.cancelShareDialog.cancelShow = false;//关闭弹窗
          this.refresh();
          //this.myShare ? this.getShareTableData() : this.getSavedShareTableData()
        })
      },
      preview(item,index) {
        // 利用替换数据的方法展示文件夹中的内容不适合于此场景
        if (item.fileType !== 'folder') return
        if (item.isCancel === 'yes') return
        if(item.pathJson){
           this.sharePathJson = item.pathJson;
        }
        this.shareTableData = [];
        this.isLoading = true
        this.selectItemArr=[];
        let share_type = parseInt(item.type)
        let isUpload = item.isUpload;
        if (item.fileType === 'folder') {
          if(this.myShare){
            this.getMyShareChildList(item,index,share_type);
          }else if(this.saveShare){//保存的分享需要加密
            if(this.pathJson.length<1&&item.type==3){//判断是否是私有分享，私有分享需要验证密码
              let getShareData = {
                shareId: this.pathJson[0]?this.pathJson[0].id:item.id,
                ud: commonstate.user.id,
                password:item.password
              }
              this.Utils.doShareRequest("check_password",getShareData).then(res=>{
                if (res.message=='success'){
                  this.getSavedChildList(item,index,item.updateTime,share_type);
                }else{
                    this.$toast({
                      text: this.$t('language.sharesPage.passWordError'),
                      type: 'fail',
                      idValue: "shareBox",
                    });
                  this.isLoading = false
                }
              })
            }else{
              let updateTime;
              if(this.pathJson[0]&&this.pathJson[0].isTransfers){
                updateTime = item.updateTime
              }else{
                updateTime = this.pathJson[0]?this.pathJson[0].updateTime:item.updateTime;
              }
              this.getSavedChildList(item,index,updateTime);
            }
        }
        }
      },
      //获取我的分享下级目录信息
      getMyShareChildList(item,index,share_type){
        if(item.isTransfers){
          //分享传输
          this.Utils.doShareRequest("get_share_transfer_files", {id: item.id}).then(res => {
            //分享传输相关
            if(res.shareFiles){
              this.isLoading = false
              this.pathJson = [];
              this.pathJson.push(item)
              this.pathJson = this.pathJsonFilter(this.pathJson);
              let shareTransferFiles = res.shareFiles;
              shareTransferFiles.forEach(v => {
                v.fileName = v.name
                v.modifiedTime = v.createTime
                v.dir = v.isDir==1?"folder":"";
                v.fileType = v.isDir==1?"folder":"file";
                v.driveType = "Shares" 
              })
              this.shareTableData = shareTransferFiles;
            } 
            this.upDownOrder(this.index)
          })
          return;
        }

        this.Utils.doFilesRequest("list", {ud: commonstate.user.id, dd: item.tokenId, id: item.fileId}).then(res => {
              /*
                  如果只是更改数据，在同一个table下显示文件夹下的内容，需要字段统一
                  fileName   type     fileSize    createTime      isUpload
                    name      -         size     modifiedTime        -
              */
              this.isLoading = false
              if (res.message === "success") {
                //2020-8-17-xth 增加路径索引
                if(index||index===0){
                  this.pathJson = this.pathJsonFilter(this.pathJson.slice(0,index+1));
                }else{
                  this.pathJson.push(item)
                  this.pathJson = this.pathJsonFilter(this.pathJson);
                }
                let folderData = []
                let temp = {}
                res.items.forEach(v => {
                  temp = {}
                  Object.assign(temp, {
                    fileName: v.name,
                    type: share_type,
                    fileSize: v.size,
                    createTime: v.modifiedTime,
                    isUpload: v.isUpload,
                    fileType: v.dir ? 'folder' : 'file',
                    //2020-8-17-xth 新增参数
                    cloudId: item.cloudId,
                    url: v.webUrl,
                    tokenId: item.tokenId,
                    parentId: res.id,
                    fileId: v.id,
                    //sort排序用
                    name: v.name,
                    size: v.size,
                    modifiedTime: v.modifiedTime,
                    dir: v.dir,
                    driveId: item.tokenId,
                    cloudType: res.cloudType,
                    id: v.id,
                    //copy用
                    driveType: 'Shares',
                    pid: res.id,
                    webUrl: v.webUrl,
                    docType: v.docType,
                  })
                    for (let j = this.pathJson.length - 1; j >= 0; j--) {
                    if (temp.pnode) {
                        //temp.pnode.pnode = this.pathJson[j];
                      } else {
                        temp.pnode = this.pathJson[j];
                      }
                    }
                  folderData.push(temp)
                })
                // 将数据替换为文件夹中的数据
                this.myShare ? this.shareTableData = folderData : this.savedShareTableData = folderData
                this.upDownOrder(this.index)
              }else if((res.message+"").indexOf("404")!==-1){
                this.$toast({
                  text: this.$t('language.sharesPage.errorShare404'),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }else if("unknownError"===res.reason){
                this.$toast({
                  text: this.$t('language.share.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }else{
                this.$toast({
                  text: this.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }
            })
      },
      //获取保存的分享下级目录信息
      getSavedChildList(item,index,updateTime,share_type){
        if(item.isTransfers){
          //分享传输
          this.Utils.doShareRequest("get_share_transfer_files", {id: item.id}).then(res => {
            //分享传输相关
            if(res.shareFiles){
              this.isLoading = false
              this.pathJson = [];
              this.pathJson.push(item)
              this.pathJson = this.pathJsonFilter(this.pathJson);
              let shareTransferFiles = res.shareFiles;
              shareTransferFiles.forEach(v => {
                v.fileName = v.name
                v.modifiedTime = v.createTime
                v.dir = v.isDir==1?"folder":"";
                v.fileType = v.isDir==1?"folder":"file";
                v.driveType = "Shares" 
              })
              this.savedShareTableData = shareTransferFiles;
            } 
            this.upDownOrder(this.index)
          })
          return;
        }
            let data = {
              shareUserId: this.pathJson[0]?this.pathJson[0].userId:item.userId,
              shareId: this.pathJson[0]?this.pathJson[0].id:item.id,
              dd: item.tokenId,
              id: item.cryptId,
              ud: commonstate.user.id,
              shareUpdateData:updateTime?updateTime:item.createTime
            }
            this.Utils.doShareFileRequest("list", data).then(res => {
            /*
                如果只是更改数据，在同一个table下显示文件夹下的内容，需要字段统一
                fileName   type     fileSize    createTime      isUpload
                  name      -         size     modifiedTime        -
            */
            this.isLoading = false
            if (res.message === "success") {
              this.selectItemArr=[];
              //2020-8-17-xth 增加路径索引
              if(index||index===0){
                this.pathJson = this.pathJsonFilter(this.pathJson.slice(0,index+1));
              }else{
                this.pathJson.push(item)
                this.pathJson = this.pathJsonFilter(this.pathJson);
              }
              let folderData = []
              let temp = {}
              res.items.forEach(v => {
                temp = {}
                Object.assign(temp, {
                  fileName: v.name,
                  type: share_type,
                  fileSize: v.size,
                  createTime: v.modifiedTime,
                  isUpload: v.isUpload,
                  fileType: v.dir ? 'folder' : 'file',
                  //2020-8-17-xth 新增参数
                  cloudId: item.cloudId,
                  url: v.webUrl,
                  tokenId: item.tokenId,
                  parentId: res.id,
                  fileId: v.id,
                  //sort排序用
                  name: v.name,
                  size: v.size,
                  modifiedTime: v.modifiedTime,
                  dir: v.dir,
                  driveId: item.tokenId,
                  cloudType: res.cloudType,
                  id: v.id,
                  //copy用
                  driveType: 'Shares',
                  pid: res.id,
                  cryptId:v.cryptId, //加密id
                  webUrl: v.webUrl,
                })

                  for (let j = this.pathJson.length - 1; j >= 0; j--) {
                  if (temp.pnode) {
                      //temp.pnode.pnode = this.pathJson[j];
                    } else {
                      temp.pnode = this.pathJson[j];
                    }
                  }
                folderData.push(temp)
              })
              // 将数据替换为文件夹中的数据
              this.savedShareTableData = folderData
              this.upDownOrder(this.index)
            }else if((res.message+"").indexOf("404")!==-1){
              this.$toast({
                text: this.$t('language.sharesPage.errorShare404'),
                type: 'fail',
                idValue: "shareBox"
              });
            }else if("unknownError"===res.reason){
                this.$toast({
                  text: this.$t('language.share.' + res.reason),
                  type: 'fail',
                  idValue: "shareBox"
                });
            }else{
              this.$toast({
                text: this.$t('language.exception.' + res.reason),
                type: 'fail',
                idValue: "shareBox"
              });
            }
          })
      },
      getItemType(type) {
        let that = this
        let type_dict = [
          that.$t("language.popup.communityShareEasy"),
          that.$t("language.popup.publicShareEasy"),
          that.$t("language.popup.privateShareEasy"),
          that.$t("language.popup.sourceShareEasy")
        ]
        return type_dict[type - 1];
      },
      getItemIsupload(isUpload) {
        let that = this
        let is_upload = [
          that.$t("language.popup.no"),
          that.$t("language.popup.yes")
        ]
        return is_upload[isUpload]
      },
      reFresh() {
        this.refresh();
      },
      refresh() {
        //加载页面时无法切换
        if(this.isLoading) return
        this.isLoading = true;
        if(this.pathJson.length<1){
          if (this.myShare) {
          this.shareTableData = []
          this.getShareTableData()
          } else {
            this.savedShareTableData = []
            this.getSavedShareTableData()
          }
        }else{
          this.preview(this.pathJson[this.pathJson.length-1],this.pathJson.length-1)
        }
        this.selectItemArr = []
      },
      gridSwitch() {
        this.listShow = !this.listShow
        let Base64 = require('js-base64').Base64;
        let userListShow = {
            uid: commonUtils.getUser().id,
            listShow: this.listShow
        }
        this.$cookies.set("gridFlag", Base64.encode(JSON.stringify(userListShow)), "1y");
      },
      //改为用户之前选择的平铺和列表效果
      getListShow() {
        if (this.$cookies.get('gridFlag')) {
            let userListShow = JSON.parse(Base64.decode(this.$cookies.get('gridFlag')));
             if (userListShow.uid == commonUtils.getUser().id) {
                this.listShow = userListShow.listShow;
            } else {
                this.listShow = true;
            }
        } else {
            this.listShow = true;
        }
      },
      clickTabTitle(type){
        //加载页面时无法切换
        if(this.isLoading) return
        if(type==1){
          this.toSaveShare()
        }else if(type==0){
          this.toMyShare()
        }
      },
      /*切换tab页相关方法*/
      toMyShare() {
        this.toTableChange()
        this.shareTableData = []
        this.myShare = true;
        this.saveShare = false;
        this.$store.commit("setSharesType", 0);
        this.getShareTableData()
        this.getShareTabBarWidth(1)
      },
      toSaveShare() {
        this.toTableChange()
        this.savedShareTableData = []
        this.saveShare = true;
        this.myShare = false;
        this.$store.commit("setSharesType", 1);
        this.getSavedShareTableData()
        this.getShareTabBarWidth(2)
      },
      toTableChange(){
        this.isAllSelected = false
        this.isLoading = true
        this.selectItemArr = []
        this.pathJson = []
        this.sharePathJson = []
        this.pathJson = [],
        this.isCancelNum = 0
        this.showLeftMenuArr = []
        this.showRightMenuArr = []
      },
      getShareTableData() {
        this.Utils.doShareRequest("select_all_share", {ud: commonstate.user.id}).then(res => {
          if (this.myShare) {
            this.isLoading = false
          }
          this.shareTableData = res.shares
          //排序
          this.shareTableData.forEach(v => {
            v.name = v.fileName
            v.size = v.fileSize
            v.modifiedTime = v.createTime
            v.dir = v.fileType=='folder'?'folder':''
            v.driveType = "Shares" //标记来自于分享管理
          })
          //分享传输相关
          if(res.shareTransfers){
            let shareTransfers = res.shareTransfers;
            shareTransfers.forEach(v => {
              v.fileName = v.name
              v.modifiedTime = v.createTime
              v.dir = 'folder'
              v.fileType ='folder'
              v.driveType = "Shares" 
              v.isTransfers = true//标记来自于分享传输
            })
            this.shareTableData = this.shareTableData.concat(shareTransfers);
          } 
          this.upDownOrder(this.index)
        })
      },
      getSavedShareTableData() {
        this.Utils.doShareRequest("select_all_saved_share", {ud: commonstate.user.id}).then(res => {
          if (this.saveShare) {
            this.isLoading = false
          }
          this.savedShareTableData = res.savedShares
          //排序
          this.savedShareTableData.forEach(v => {
            v.name = v.fileName
            v.size = v.fileSize
            v.modifiedTime = v.createTime
            v.dir = v.fileType=='folder'?'folder':''
            //处理数据用
            v.driveType = 'Shares'//很重要，判断是否是分享任务的依据
            v.driveId = v.tokenId
          })
          //分享传输相关
          if(res.savedSharesTransfers){
            let shareTransfers = res.savedSharesTransfers;
            shareTransfers.forEach(v => {
              v.fileName = v.name
              v.modifiedTime = v.createTime
              v.dir = 'folder'
              v.fileType ='folder'
              v.driveType = "Shares" 
              v.isTransfers = true//标记来自于分享传输
            })
            this.savedShareTableData = this.savedShareTableData.concat(shareTransfers);
          } 
          this.upDownOrder(this.index)
        })
      },
      /*页面功能相关*/
      getFileImg(file) {
        if (file.fileType === 'folder') {
          if(file.docType){
            return file.docType?file.docType=='ALBUM'?'album':'folder':'folder';
          }else{
            return "folder"
          }
        } else {
          return commonUtils.matchfileTypes(file.fileName)
        }
      },
      matchfileType(name) {
        return commonUtils.matchfileTypes(name)
      },
      matchfolderType(docType) {
        return docType?docType=='ALBUM'?'album':'folder':'folder';
      },
      //选中文件
      addTableCheck(item,isClean) {
        //this.shareRightMenuShow = !this.shareRightMenuShow
        // if (this.shareRightMenuShow) return
        if(isClean){
          this.selectItemArr=[]
          this.selectItemArr.push(item);
        } else if (this.selectItemArr.includes(item)) {
          this.selectItemArr = this.selectItemArr.filter((v) => {
            return v.fileId !== item.fileId
          })
        } else {
          this.selectItemArr.push(item);
        }
      },
      selectAll() {
        this.isAllSelected = !this.isAllSelected
        if (!this.isAllSelected) {
          this.selectItemArr = []
          this.isCancelNum = 0
        }
      },
      goTo() {
        this.shareRightMenuShow = false
        this.moreChooseShow = false
        let url;
        if(this.pathJson.length<1){
          url = this.selectItemArr[0].url
          //私有分享携带密码
          if(this.selectItemArr[0].type=='3'){
            this.setPrivatePassword(this.selectItemArr[0]);
          }
        }else{
          url = this.pathJson[0].url
          if(this.pathJson[0].type=='3'){
            this.setPrivatePassword(this.pathJson[0]);
          }
        }
        window.open(url)
      },
      setPrivatePassword(item){
        let passwordData = { id: item.id, password: item.password }
        this.$store.commit("setSharesPassWordJson", passwordData);
      },
      shareRightMenuOpen(event, item) {
        /*
          右键菜单的显示内容取决于:
              - 点击右键时，选择的文件为多个
              - 点击右键时，选择的的文件为1个
        */
        this.moreChooseShow = false;
        if (this.shareRightMenuShow) {
          // 如果右键菜单已经显示，再右键其他项，则清空选择
          this.selectItemArr = []
        }
        if (!this.selectItemArr.includes(item)) {
          if(this.selectItemArr.length<2){
            this.selectItemArr = [];
          }
          this.selectItemArr.push(item)
        }
        let element = event.currentTarget;
        this.shareRightMenuShow = true; //右键菜单显示
        this.$nextTick(function () { //界面渲染完毕后，执行鼠标右键点击显示，右键菜单始终随着鼠标显示方法
          commonUtils.multipleMenuShow("shareRightMenu", event);
        });
      },
      shareRightMenuClose() {
        this.shareRightMenuShow = false;
      },
      toHomePage() {
        //加载中无法点击
        if(this.isLoading) return
        if(this.myShare){
          this.toMyShare();
        }else if(this.saveShare){
          this.toSaveShare();
        }
      },
      comeBackFile(event, path ,index) {
        //加载页面时无法切换
        if(this.isLoading) return
        if (path.id != 'addEllipsis') {
          this.preview(path,index);
        }
      },
      //预览文件
      previewPageShow() {
        if (this.selectItemArr[0].isCancel === 'yes') return
          this.shareRightMenuShow = false;
        if(this.myShare){
          let previewData = {
              ud: commonUtils.getUser().id,
              dd: this.selectItemArr[0].tokenId,
              id: this.selectItemArr[0].fileId,
              n: this.selectItemArr[0].fileName
          };
          if(this.selectItemArr[0].webUrl){
            previewData.webUrl = this.selectItemArr[0].webUrl;
          }
            this.Utils.doFilesRequest("download.createSession", previewData).then(result => {
              if(result.download_id){
                this.selectItemArr[0].url = commonUtils.createPreviewLinkForm(result.download_id);
              this.selectItemArr[0].name = this.selectItemArr[0].fileName;//统一字段名
              this.$store.commit('setPreviewData', this.selectItemArr);+
              this.$store.commit("setCacheShareTableDatas", {
                          id: this.selectItemArr[0].fileId,
                          pathJson: this.pathJson?this.pathJson:{}
                      });
              this.$router.push({
                  name: "preview"
              });
              }else if((result.msg+"").indexOf("404")!==-1){
                this.$toast({
                  text: this.$t('language.sharesPage.errorShare404'),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }else{
                this.$toast({
                  text: result.msg,
                  type: 'fail',
                  idValue: "shareBox"
                });
              }

            });
        }else if(this.saveShare){//保存的分享预览需要加密id
           let previewData = {
              ud: commonUtils.getUser().id,
              dd: this.selectItemArr[0].tokenId,
              id: this.selectItemArr[0].cryptId,
              n: this.selectItemArr[0].fileName,
              shareUserId: this.pathJson[0]?this.pathJson[0].userId:this.selectItemArr[0].userId,
              shareId: this.pathJson[0]?this.pathJson[0].id:this.selectItemArr[0].id,
              shareUpdateData:this.pathJson[0]?this.pathJson[0].updateTime:this.selectItemArr[0].updateTime
          };
          if(this.selectItemArr[0].webUrl){
            previewData.webUrl = this.selectItemArr[0].webUrl;
          }
            this.Utils.doShareFileRequest("download.createSession", previewData).then(result => {
              if(result.download_id){
                this.selectItemArr[0].url = commonUtils.createPreviewLinkForm(result.download_id);
              this.selectItemArr[0].name = this.selectItemArr[0].fileName;//统一字段名
              this.$store.commit('setPreviewData', this.selectItemArr);+
              this.$store.commit("setCacheShareTableDatas", {
                          id: this.selectItemArr[0].fileId,
                          pathJson: this.pathJson?this.pathJson:{}
                      });
              this.$router.push({
                  name: "preview"
              });
              }else if((result.msg+"").indexOf("404")!==-1){
                this.$toast({
                  text: this.$t('language.sharesPage.errorShare404'),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }else{
                this.$toast({
                  text: result.msg,
                  type: 'fail',
                  idValue: "shareBox"
                });
              }

            });
        }
      },
      shareDialgOpen() {//打开修改分享弹窗
        if(this.selectItemArr[0].isTransfers){
          //分享传输相关
          sessionStorage.removeItem("share_transfer")
          sessionStorage.setItem("share_transfers_id", this.selectItemArr[0].id);
          let routerUrl =  this.$router.resolve({
            name: 'shareTransfer',
          });
          window.open(routerUrl.href,'_blank');
          return;
        }
        this.$refs.shareDialog.fileInfo = { 
          id:this.selectItemArr[0].fileId,
          driveId:this.selectItemArr[0].tokenId,
          name:this.selectItemArr[0].name,
          pathJson: this.selectItemArr[0].pathJson,
          dir:this.selectItemArr[0].dir=="folder"?true:false,
          pid:this.selectItemArr[0].parentId,
          password:this.selectItemArr[0].password?this.selectItemArr[0].password:'',
          driveType:this.selectItemArr[0].cloudId
        }
        this.shareRightMenuShow = false;
        this.moreChooseShow = false
        //根据所选文件初始化弹窗，如果该文件已分享则进入分享禁用弹窗 2020/8/10-xth
        this.$refs.shareDialog.linkCreatedInit(this.selectItemArr[0]);
      },
      cancelShareDialgOpen() {//打开取消分享确认弹窗
        this.$refs.cancelShareDialog.cancelShow = true;
        this.shareRightMenuShow = false;
        this.moreChooseShow = false
      },
      toSource() {
            let that = this;
            let id;
            let fileName;
            let selectItem = this.selectItemArr[0];
            if (selectItem.pnode) {
                id = selectItem.pnode.fileId;
                fileName = selectItem.pnode.fileName;
            }else if(selectItem.pathJson){
                id = selectItem.pathJson.json[selectItem.pathJson.json.length-1].id;
                fileName = selectItem.pathJson.json[selectItem.pathJson.json.length-1].name;
            } else {
                id = selectItem.fileId;
                fileName = selectItem.fileName;
            }
            let listData = new cloudExploerUtils.filelistData(id, commonUtils.getUser().id, selectItem.tokenId, null, null, null);
            that.$store.commit("setCatalogFileId", selectItem.fileId);
            that.searchResultShow = false;
            that.searchMenuShow = false;
            let pathData = this.$store.state.pathJson[selectItem.fileId + selectItem.tokenId];
            that.encapsulationPath(selectItem,pathData);
            that.pathJson = [];
            that.$forceUpdate();
            let sourId = that.$store.state.catalogFileId;
            let teamCloud = that.$store.getters.getTeamCloud;
            //如果有team信息且是team的分享，则跳转team页面
            if(teamCloud&&teamCloud.categoryId==selectItem.cloudId){
              let dom;
              $.each(that.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$children[i];
                    return;
                }
              });
              dom.menuClickCurrent = 8;
              that.$store.commit("setCatalogFileId", sourId);
              that.$router.push({
                  name: "subAccountTeam",
                  query: {
                      cloudType: selectItem.cloudId,
                      folderId: selectItem.parentId,
                      folderName: fileName,
                      tokenId: selectItem.tokenId,
                      cloudId: selectItem.tokenId,
                  }
              });
            }else{
              //选中左侧菜单
            that.selectLeftOption(selectItem);
             //选中跳转文件
            that.$store.commit("setCatalogFileId", sourId);
             //通过cloudId获取cloudType
            let cloud = commonstate.cloudCategories.filter(function (cloud){return cloud.id == selectItem.cloudId})
            let cloudType = selectItem.cloudId;//默认cloudId
            if(cloud.length>0){
              cloudType = cloud[0].appName;
            }
             that.$router.push({
                 name: "cloudExploer",
                 query: {
                     cloudType: cloudType,
                     folderId: selectItem.parentId,
                     folderName: fileName,
                     tokenId: selectItem.tokenId,
                 }
             });
            }
        },
        //选中左侧菜单
        selectLeftOption(selectItem) {
            let dom;
            let that = this;
            $.each(that.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$children[i];
                    return;
                }
            });
            dom.driveOptionSelect(selectItem.tokenId);
        },
        topRightMenuShow() {
          this.moreChooseShow = !this.moreChooseShow;
        },
        topRightMenuShowClose() {
          this.moreChooseShow = false;
        },
        pathJsonFilter(newValue) {//路径超长处理
            let subArray = new Array();
            let subArrayOne = new Array();
            let subArrayTwo = new Array();
            let clonArr = newValue;
            if (clonArr.length >= 11) {
                subArrayOne = clonArr.slice(0, 5);
                subArrayTwo = clonArr.slice(clonArr.length - 5);
                $.each(subArrayOne, function (i, item) {
                    subArray.push(item);
                });
                let sbuData = {
                    id: 'addEllipsis',
                    fileName: '... ...'
                }
                subArray.push(sbuData);
                $.each(subArrayTwo, function (j, data) {
                    subArray.push(data);
                });
            } else {
                subArray = clonArr;
            }
            return subArray;
        },
        //如果没有path，则封装Path数据
        encapsulationPath(sourceAimData, item) {
          let pathJson = [];
          if(item){
            this.$store.commit("setPathJson", {
              folderId: sourceAimData.parentId + sourceAimData.tokenId,
              json: []
            });
          }
          //根目录有路径地址和路径地址的，拼接2个地址，没有的以根目录路径地址为准
          if(this.sharePathJson&&this.pathJson.length>0){
            pathJson = this.sharePathJson.json
            this.pathJson.forEach(function(e,index){
              pathJson.push({
                id: e.fileId,
                name: e.fileName,
                driveId: e.tokenId
              });
            })
            let JsonList = Object.assign([], pathJson);
              this.$store.commit("setPathJson", {
              folderId: sourceAimData.parentId + sourceAimData.tokenId,
              json: JsonList
            });
          }else{
            pathJson = sourceAimData.pathJson.json
            let JsonList = Object.assign([], pathJson);
              this.$store.commit("setPathJson", {
              folderId: sourceAimData.parentId + sourceAimData.tokenId,
              json: JsonList
            });
          }
        },
        changeUpDownOrder(index){//排序
          if(this.index === index){//选中其他index时，不改变升降序
            this.upShow = !this.upShow;
          }
          this.index = index;
          this.upDownOrder(this.index);
        },
        upDownOrder(index) {//排序
          //0文件名 3表示type 1表示size 2表示ShareOn
          if(this.myShare){
            this.shareTableData = commonUtils.sortArr(this.shareTableData, this.upShow, this.index);
          }else if(this.saveShare){
            this.savedShareTableData = commonUtils.sortArr(this.savedShareTableData, this.upShow, this.index);
          }
        },
        copyFile() {//复制
          let copyArr = {};
          //全选的情况下，默认传递上级目录（仅子目录）
          if(this.isAllSelected&&this.pathJson.length>0&&!this.pathJson[this.pathJson.length-1].isTransfers){
            let dataArr = []
            dataArr.push(this.pathJson[this.pathJson.length-1])
            copyArr = this.dataPro(dataArr);
          }else{
            copyArr = this.dataPro(this.selectItemArr);
          }
          if(copyArr.length<1){
            return;
          }
          this.shareDataArr = copyArr;
          this.$store.commit("setCopyArr", copyArr);
          this.$store.commit("setCopyFolderId", this.$route.query.folderId);
          this.shareRightMenuShow = false;
          this.currentIndex = -1;
        },
        dblclickShare(item){//双击事件
          switch (item.fileType) {
            case 'file':
              this.dblclickFile(item)
              break;
            case 'folder':
              this.preview(item)
              break;
            default:
              break;
          }
        },
        dblclickFile(item){//双击打开预览
          if(item.fileType !== 'file') return
          if (item.isCancel === 'yes') return
          if(this.myShare){
            let previewData = {
                ud: commonUtils.getUser().id,
                dd: item.tokenId,
                id: item.fileId,
                n: item.fileName
            };
            let itemArr = []
            itemArr.push(item);
            if(item.webUrl){
              previewData.webUrl = item.webUrl;
            }
            this.Utils.doFilesRequest("download.createSession", previewData).then(result => {
              if(result.download_id){
                item.url = commonUtils.createPreviewLinkForm(result.download_id);
                item.name = item.fileName;//统一字段名
                this.$store.commit('setPreviewData', itemArr);
                this.$store.commit("setCacheShareTableDatas", {
                  id: item.fileId,
                  pathJson: this.pathJson?this.pathJson:{}
                });
                this.$router.push({
                    name: "preview"
                });
              }else if((result.msg+"").indexOf("404")!==-1){
                this.$toast({
                  text: this.$t('language.sharesPage.errorShare404'),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }

            });
          }else if(this.saveShare){
            let previewData = {
                ud: commonUtils.getUser().id,
                dd: item.tokenId,
                id: item.cryptId,
                n: item.fileName,
                shareUserId: this.pathJson[0]?this.pathJson[0].userId:this.selectItemArr[0].userId,
                shareId: this.pathJson[0]?this.pathJson[0].id:this.selectItemArr[0].id,
                shareUpdateData:this.pathJson[0]?this.pathJson[0].updateTime:this.selectItemArr[0].updateTime
            };
            let itemArr = []
            itemArr.push(item);
            if(item.webUrl){
              previewData.webUrl = item.webUrl;
            }
            this.Utils.doShareFileRequest("download.createSession", previewData).then(result => {
              if(result.download_id){
                item.url = commonUtils.createPreviewLinkForm(result.download_id);
                item.name = item.fileName;//统一字段名
                this.$store.commit('setPreviewData', itemArr);
                this.$store.commit("setCacheShareTableDatas", {
                  id: item.fileId,
                  pathJson: this.pathJson?this.pathJson:{}
                });
                this.$router.push({
                    name: "preview"
                });
              }else if((result.msg+"").indexOf("404")!==-1){
                this.$toast({
                  text: this.$t('language.sharesPage.errorShare404'),
                  type: 'fail',
                  idValue: "shareBox"
                });
              }

            });
          }
        },
        //按住shift键多选
        multipleBox(index) {
          if(this.myShare){
            let allData = Object.assign([], this.shareTableData);
            if (this.firstIndex != -1) {
                if (this.firstIndex <= index) {
                    this.selectItemArr = this.shareTableData.slice(this.firstIndex, index + 1);
                } else {
                    this.selectItemArr = this.shareTableData.slice(index, this.firstIndex + 1);
                }
            }
          }
        },
        copyToDialogShow() {//打开copyTo弹窗
            //全选的情况下，默认传递上级目录（仅子目录）
            if(this.isAllSelected&&this.pathJson.length>0&&!this.pathJson[this.pathJson.length-1].isTransfers){
              let dataArr = []
              dataArr.push(this.pathJson[this.pathJson.length-1])
              this.shareDataArr = this.dataPro(dataArr);
            }else{
              this.shareDataArr = this.dataPro(this.selectItemArr);
            }

            if(this.shareDataArr.length<1){
              return;
            }
            this.$refs.copyToDialog.copyToShow = true;
            this.$refs.copyToDialog.initData();
            this.$store.state.exploerselectedArr = this.shareDataArr;
            this.$refs.copyToDialog.shareDataArr=this.shareDataArr
            this.shareRightMenuShow = false;
        },
        //处理数据
        dataPro(dataArr){
          let copyArr = []
          let that = this;
          let isReturn = false;
          if(this.pathJson.length<1||(this.pathJson.length==1&&this.pathJson[0].isTransfers)){
            dataArr.forEach(function(e,index){
              if(that.shareTransferCanotCopy(e)&&!isReturn){
                let temp = {
                  cloud: {},
                  dir: e.dir=='folder'?true:false,
                  driveId: e.driveId,
                  driveType: e.driveType,
                  id: e.fileId,
                  modifiedTime: e.modifiedTime,
                  name: e.name,
                  pid: e.parentId,
                  size: e.size,
                  webUrl: e.url,
                  shareUrl: e.url,
                  way: "share"
                };
                temp.sharePath = that.addSharePath(e,[])
                temp.pnode = that.addPnode(temp,e.pathJson.json)
                copyArr.push(temp);
              }else{
                copyArr = [];
                isReturn = true;
                return;
              }
            })
          }else{
            dataArr.forEach(function(e,index){
              if(that.shareTransferCanotCopy(e)&&!isReturn){
              let temp = {
                cloud: {},
                dir: e.dir=='folder'?true:false,
                driveId: e.driveId,
                driveType: e.driveType,
                id: e.fileId,
                modifiedTime: e.modifiedTime,
                name: e.name,
                pid: e.parentId,
                size: e.size,
                webUrl: e.url,
                shareUrl: that.pathJson[0].url,
                way: "share"
              };
              e.pnode = {};
              temp.sharePath = that.addSharePath(e,that.pathJson)
              temp.pnode = that.addPnode(temp,that.sharePathJson.json.concat(that.pathJson))
              copyArr.push(temp);
              }else{
                copyArr = [];
                isReturn = true;
                return;
              }
            })
          }
          return copyArr
        },
        //拼装pnode
        addPnode(item,pathJson){
          let temp = item;
          let that=this
          for (let j = pathJson.length - 1; j >= 0; j--) {
            that.addsPnode(temp,pathJson[j])
          }
          return temp.pnode
        },
         //拼装sharePath
        addSharePath(item,pathJson){
          let arr = [{
            cloudType: "Shares",
            fileId: item.id,
            cryptId: item.cryptId,
            fileName: item.name,
            name: item.name,
            tokenId: item.driveId,
            fileType: item.fileType,
            isCancel: item.isCancel,
          }]
          let that=this
          for (let j = pathJson.length - 1; j >= 0; j--) {
            arr.push({
              cloudType: "Shares",
              fileId: pathJson[j].id,
              cryptId: pathJson[j].cryptId,
              fileName: pathJson[j].name,
              name: pathJson[j].name,
              tokenId: pathJson[j].driveId,
              fileType: pathJson[j].fileType,
              isCancel: pathJson[j].isCancel,
            })
          }
          return arr
        },
        addsPnode(temp,path){
            if (temp.pnode) {
              this.addsPnode(temp.pnode,path);
            } else {
              temp.pnode = {
                driveId: path.driveId,
                id: path.id,
                name: path.name
              }
            }
        },
        judgeShowMenu(){//判断显示的菜单权限范围
          if(this.selectItemArr.length < 1){//未选择时
            this.showLeftMenuArr = []
            this.showRightMenuArr = []
            return
          }
          if(this.myShare){
            if(this.pathJson.length<1){//根目录下
              if(this.selectItemArr.length == 1){//单选
                switch (this.selectItemArr[0].fileType){
                  case "file":
                    this.showLeftMenuArr = ["cancel","edit_share","download","more","more_preview","more_to_source","more_to_share"]
                    this.showRightMenuArr = ["cancel","edit_share","download","preview","to_source","to_share"]
                    break
                  case "folder":
                    this.showLeftMenuArr = ["cancel","edit_share","to_source","to_share"]
                    this.showRightMenuArr = ["cancel","edit_share","to_source","to_share"]
                    break
                  default:
                    this.showLeftMenuArr = []
                    this.showRightMenuArr = []
                    break
                }
              }else {//多选
                this.showLeftMenuArr = ["cancel"]
                this.showRightMenuArr = ["cancel"]
              }
            }else{//子目录下
              if(this.selectItemArr.length == 1){//单选
                switch (this.selectItemArr[0].fileType){
                  case "file":
                    this.showLeftMenuArr = ["download","preview","to_source","to_share"]
                    this.showRightMenuArr = ["download","preview","to_source","to_share"]
                    break
                  case "folder":
                    this.showLeftMenuArr = ["to_source","to_share"]
                    this.showRightMenuArr = ["to_source","to_share"]
                    break
                  default:
                    this.showLeftMenuArr = []
                    this.showRightMenuArr = []
                    break
                }
              }else {//多选
                this.showLeftMenuArr = ["to_share"]
                this.showRightMenuArr = ["to_share"]
              }
            }
          }else if(this.saveShare){
            if(this.selectItemArr.filter(item=> item.isCancel == "yes").length>0){
              this.showLeftMenuArr = ["remove"]
              this.showRightMenuArr = ["remove"]
              return
            }
            if(this.pathJson.length<1){//根目录下
              if(this.selectItemArr.length == 1){//单选
                switch (this.selectItemArr[0].fileType){
                  case "file":
                    this.showLeftMenuArr = ["copy_to","download","remove","more","more_preview","more_copy","more_copy_link","more_to_share"]
                    this.showRightMenuArr = ["copy_to","download","remove","preview","copy","copy_link","to_share"]
                    break
                  case "folder":
                    this.showLeftMenuArr = ["copy_to","remove","copy","more","more_copy_link","more_to_share"]
                    this.showRightMenuArr = ["copy_to","remove","copy","copy_link","to_share"]
                    break
                  default:
                    this.showLeftMenuArr = []
                    this.showRightMenuArr = []
                    break
                }
              }else {//多选
                this.showLeftMenuArr = ["copy_to","copy","remove"]
                this.showRightMenuArr = ["copy_to","copy","remove"]
              }
            }else{//子目录下
              if(this.selectItemArr.length == 1){//单选
                switch (this.selectItemArr[0].fileType){
                  case "file":
                    this.showLeftMenuArr = ["copy_to","download","preview","more","more_copy","more_copy_link","more_to_share"]
                    this.showRightMenuArr = ["copy_to","download","preview","copy","copy_link","to_share"]
                    break
                  case "folder":
                    this.showLeftMenuArr = ["copy_to","copy","copy_link","to_share"]
                    this.showRightMenuArr = ["copy_to","copy","copy_link","to_share"]
                    break
                  default:
                    this.showLeftMenuArr = []
                    this.showRightMenuArr = []
                    break
                }
              }else {//多选
                this.showLeftMenuArr = ["copy_to","copy"]
                this.showRightMenuArr = ["copy_to","copy"]
              }
            }
          }else {
            this.showLeftMenuArr = []
            this.showRightMenuArr = []
          }
        },
        judgeShowLeftMenu(menuName){
          return this.showLeftMenuArr.includes(menuName);
        },
        judgeShowRightMenu(menuName){
          return this.showRightMenuArr.includes(menuName);
        },
        judgeShowLeftMenuBorder(menuName){
          return this.showLeftMenuArr[0]==menuName;
        },
        snapTasksOpen() {//临时任务
            this.$store.state.snapTaskShow = ! this.$store.state.snapTaskShow;
        },
        cancelUpload: function (data) {
            let that = this;
            if (commonstate.source) {
                commonstate.source.cancel('取消上传' + data);
                // if (that.$refs.snapTaskDialog.items.length > 0) {
                //     that.uploadFileChange();
                // }
            }
        },
        onfocusEvent() {
            this.isflage = true;
        },
        //左上角菜单宽度控制
        getWidth() {
            let result;
            if (this.$i18n.locale == 'english') {
                result = 115 + 'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
                result = 165 + 'Px';
            }
            if (this.$i18n.locale == 'france') {
                result = 125 + 'Px';
            }
            if (this.$i18n.locale == 'portuguese') {
                result = 185 + 'Px';
            }
            if (this.$i18n.locale == 'japanese') {
                result = 130 + 'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese') {
                result = 125 + 'Px';
            }
            if (this.$i18n.locale == 'chinese') {
                result = 125 + 'Px';
            }
            if (this.$i18n.locale == 'italian') {
                result = 175 + 'Px';
            }
            if (this.$i18n.locale == 'spanish') {
                result = 145 + 'Px';
            }
            if (this.$i18n.locale == 'nederlands') {
                result = 145 + 'Px';
            }
            return result;
        },
        getTextWidth(index) {
            let result;
            if (this.$i18n.locale == 'english') {
              result = [65,85,85,75,85,75,52,75,75,55,85,150][index-1]+'Px';
            }
            if (this.$i18n.locale == 'deutsch') {
              result = [85,140,105,80,85,65,52,110,80,80,110,150][index-1]+'Px';
            }
            if (this.$i18n.locale == 'france') {
              result = [70,105,95,65,95,100,52,90,85,60,100,150][index-1]+'Px';
            }
            if (this.$i18n.locale == 'portuguese') {
              result = [70,165,65,120,90,100,52,95,65,65,100,165][index-1]+'Px';
            }
            if (this.$i18n.locale == 'japanese') {
              result = [90,75,100,85,75,60,52,75,50,60,115,160][index-1]+'Px';
            }
            if (this.$i18n.locale == 'traditionalChinese') {
              result = [55,75,55,55,100,100,52,65,55,55,100,150][index-1]+'Px';
            }
            if (this.$i18n.locale == 'chinese') {
              result = [55,75,55,55,100,100,52,65,55,55,75,150][index-1]+'Px';
            }
            if (this.$i18n.locale == 'italian') {
              result = [80,150,70,85,80,115,55,75,75,55,85,158][index-1]+'Px';
            }
            if (this.$i18n.locale == 'spanish') {
              result = [75,120,85,100,90,95,50,75,70,65,105,145][index-1]+'Px';
            }
            if (this.$i18n.locale == 'nederlands') {
              result = [80,105,90,85,80,70,55,100,85,70,85,158][index-1]+'Px';
            }
            return result;
        },
        //标签页宽度控制
        getShareTabBarWidth(v){
          let result;
          let transform;
          let val = this.$i18n.locale;
          if(v===1){
            switch (val) {
              case 'english':
                result = 110;
                break;
              case 'deutsch':
                result = 160;
                break;
              case 'france':
                result = 135;
                break;
              case 'portuguese':
                result = 140;
                break;
              case 'japanese':
                result = 175;
                break;
              case 'traditionalChinese':
                result = 95;
                break;
              case 'chinese':
                result = 95;
                break;
              case 'italian':;
                result = 155
                break;
              case 'spanish':
                result = 190;
                break;
              case 'nederlands':
                result = 135;
                break;
              default:
                result = 110
                break;
            }
            transform = 0;
          }else if(v==2){
            switch (val) {
              case 'english':
                result = 140;
                transform = 145;
                break;
              case 'deutsch':
                result = 220;
                transform = 190;
                break;
              case 'france':
                result = 190;
                transform = 170;
                break;
              case 'portuguese':
                result = 240;
                transform = 170;
                break;
              case 'japanese':
                result = 195;
                transform = 215;
                break;
              case 'traditionalChinese':
                result = 115;
                transform = 135;
                break;
              case 'chinese':
                result = 115;
                transform = 135;
                break;
              case 'italian':
                result = 186;
                transform = 185;
                break;
              case 'spanish':
                result = 240;
                transform = 215;
                break;
              case 'nederlands':
                result = 200;
                transform = 165;
                break;
              default:
                result = 140;
                transform = 145;
                break;
            }
          }
          this.shareTabBarWidth = result+'Px';
          this.shareTabBarTransform = transform+'Px'
        },
        //是否显示more标签控制
        checkBoxWidth(){
          let that=this;
          let flag;
          let box=this.$refs.menuList;
          let menuList=this.$refs.menuButtonList;
          if(box&&menuList&&box.clientWidth&&menuList.clientWidth&&(box.clientWidth-menuList.clientWidth)<151){
              that.showMore=true;
          }else{
              that.showMore=false;
          }
          that.$forceUpdate();
        },
        reacquireData() {
          //跳转页面进入时，从cacheShareTableDatas获取pathJson路径，并清空cacheShareTableDatas（目前只有预览返回时用）
          let tempDate = this.$store.state.cacheShareTableDatas
          this.pathJson = tempDate.pathJson
          if(this.$store.state.sharesType==0){
            this.myShare = true
            this.saveShare = false
          }else if(this.$store.state.sharesType==1){
            this.myShare = false
            this.saveShare = true
          }
          //路径为空时，进入根目录
          if(tempDate.id===this.$route.query.fileId&&this.pathJson.length>0){
            this.comeBackFile('',this.pathJson[this.pathJson.length-1],this.pathJson.length-1)
            this.$store.commit("setCacheShareTableDatas", '');
          }else{
            this.$store.commit("setCacheShareTableDatas", '');
            if(this.myShare){
              this.toMyShare()
            }else if(this.saveShare){
              this.toSaveShare()
            }else{
              this.toMyShare()
            }
          }
        },
        //如果编辑分享并更新过，则更新list相同shareId的对象
        updateShare(shareData){
          let index = this.shareTableData.findIndex(item => item.id == shareData.id);
          this.shareTableData[index].type = shareData.type;
          this.shareTableData[index].password = shareData.password;
          this.shareTableData[index].url = shareData.url;
          this.selectItemArr = [this.shareTableData[index]];
        },
        //判断是否展示toSource按钮
        showToSource(type){
          var isToSource = this.judgeShowLeftMenu(type);
          if(isToSource){
            if(this.pathJson.length>0){
              //下级目录
              isToSource = !this.pathJson[0].isTransfers;
            }else{
              //初始目录
              isToSource = !this.selectItemArr[0].isTransfers;
            }
          }
          return isToSource
        },
        //判断分享传输任务不能参与复制
        shareTransferCanotCopy(date){
          if(date.isTransfers){
            this.$toast({
              text: this.$t('language.exception.shareTransferCanotCopy'),
              type: 'fail',
              idValue: "shareBox"
            });
            return false;
          }
          return true
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 30) {
                return value.slice(0, 30) + '...';
            }
            return value;
        },
        ellipsisOther(value) {
            if (!value) return '';
            if (value.length > 15) {
                return value.slice(0, 15) + '...';
            }
            return value;
        },
        ellipsisNavi(value) {
            let subStr;
            if (!value) return '';
            if (value.length > 14) {
                subStr = value.slice(0, 6) + '..' + value.slice(value.length - 6, value.length)
            } else {
                subStr = value;
            }
            return subStr;
        }
    }
  }
</script>

<style scoped>
  .table-tr-hover {
    background: #ebf3fe !important;
  }

  .disable-tr {
    /*置灰文件名*/
    color: #c0c3c7 !important;
  }

  .file-name {
    width: calc(100% - 125px);/*no*/
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .share-name-position {
    /*float: left;*/
    display: inline-block;
  }

  .share-file-position {
    margin-right: 20px;
    /*no*/
  }

  .shares-up {
    height: 100px;
    /*no*/
    width: 100%;
    float: left;
    background-color: #f2f7fe;
    padding: 0% 2% 0% 2%;
    position: relative;
    box-sizing: border-box;
  }

  .share-all {
    position: relative;
    height: 30px;
    /*no*/
    margin: 0.04rem 0 0.04rem 0;

  }

  .share-list {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -150px -248px;
    /*no*/
  }

  .share-list-position {
    margin-left: 10px;
    /*no*/
    float: right;
  }

  .share-list:hover:after {
    content: attr(data-title);
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 3;
    box-sizing: border-box;
    margin: 0;
    white-space: nowrap;
  }

  .share-body {
    float: left;
    width: 100%;
    height: calc(100% - 100px);
    /*no*/
    box-sizing: border-box;
  }

  .my-shares-table {
    width: 96%;
    height: 96%;
    background: #fff;
    border: 1px solid #cdddf5;
    /*no*/
    margin: 0 2% 0 2%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .my-share {
    float: left;
        margin-top: 5px;/*no*/
  }

  .save-shares {
    float: left;
    margin-left: 40px;
    /*no*/
    margin-top: 5px;/*no*/
  }

  .my-share-icon-position {
    position: relative;
    top: 2px;
    /*no*/
    margin-right: 10px;
    /*no*/
    margin-left: 5px;
    /*no*/

  }

  .share-color {
    color: #6f7886;
  }

  .share-color-click {
    color: #000;
    font-weight: bold;
  }

  .save-share-icon-position {
    position: relative;
    top: 2px;
    /*no*/
    margin-right: 10px;
    /*no*/
  }

  .share-tab-bar {
    height: 3px;
    /*no*/
    position: absolute;
    background-color: #5562b4;
    bottom: 0;
    right: 0;
    top: 30px;
    /*no*/
    left: 5px;
    /*no*/
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition-property: transform, -webkit-transform;
    transition-duration: 0.3s, 0.3s;
    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1),
    cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .share-icons {
    width: 80px;
    /*no*/
    height: 20px;
    /*no*/
    position: relative;
    float: right;
    top: 18%;
  }

  .share-check-position {
    position: relative;
    top: 5px;
    /*no*/
  }

  .name-edit-div-share {
    float: left;
    height: 100%;
    margin: 0px;
    /*no*/
    padding-left: 1px;
    /*no*/
    border: none !important;
    color: #6f7886;
    font-size: 14px;
    /*no*/
  }

  .name-edit-div-share:hover {
    color: #4181ff;
    text-decoration: underline;
    cursor: pointer;
  }



/*导航栏面包屑用css*/

  .separate_icon {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -493px -201px;
    /*no*/
  }

  .separate-icon-position {
      float: left;
  }

  .name-title {
    float: left;
    position: relative;
    top: 7px;
    /*no*/
}

.name-desc {
    float: left;
    position: relative;
    top: 5px;
    /*no*/
}

.add-Ellipsis {
    float: left;
    position: relative;
    top: 5px;
    /*no*/
}

.name-desc-one {
    float: left;
    position: relative;
}

.name-desc:hover {
    text-decoration: underline;
    cursor: pointer;
}

.text-bold {
    color: #000;
    font-weight: bold;
    position: relative;
    top: 5px;
    /*no*/
    float: left;
}

.navigation {
    height: 40%;
    width: calc(100% - 30px);
    /*no*/
    float: left;
}

.navigation-recycle {
    height: 40%;
    width: calc(100% - 30px);
    /*no*/
    float: left;
    position: relative;
    top: 5px;
    /*no*/
}

.menu-bar {
    width: 100%;
    height: 40px;
    /*no*/
    float: left;
}

.menu-bar-search {
    position: relative;
    top: 5px;
    /*no*/
}

.menu-bar-recycle {
    position: relative;
    top: -6px;
    /*no*/
    width: 140px;
    /*no*/
    float: right !important;
}

.triangle {
    height: 0;
    width: 0;
    overflow: hidden;
    font-size: 0;
    /*no*/
    line-height: 0;
    border-color: transparent transparent transparent #5562b4;
    border-style: solid dashed dashed dashed;
    border-width: 4px;
    /*no*/
}

.triangle-position {
    position: relative;
    left: 75px;
    /*no*/
    top: 11px;
    /*no*/
    margin: 0;
    float: left;
}


.navigation-path {
    font-size: 14px;
    /*no*/
    color: #687886;
    word-break: keep-all;
    white-space: nowrap;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 30px;
    /*no*/
}

#navigation {
    height: 40px;
    /*no*/
    position: relative;
}

#navigation table {
    width: auto;
    table-layout: fixed;
}

#navigation table td {
    word-break: keep-all;
    white-space: nowrap;
}

.separate_icon {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -493px -201px;
    /*no*/
}

#shareList .home-icon-position {
    float: left;
    position: relative;
    top: 7px;
    /*no*/
    cursor: pointer;
    margin-right: 5px;/*no*/
}

.operating {
    float: left;
    position: relative;
    top: 3px;
    /*no*/
}

.menu-button {
    position: relative;
    top: 3%;
    height: 30px;
    /*no*/
    float: left;
}

.icon-position {
    float: left;
    position: relative;
}

.more-position {
    float: left;
    position: relative;
}

.more {
    float: left;
    position: relative;
    top: 3px;
    /*no*/
}

.file-narrow-position {
    position: relative;
    top: 3Px;/*no*/
}

.file-narrow-position:hover {
    cursor: pointer;
}

.narrow-position-two {
    position: relative;
    top: 3Px;
}

.narrow-position-two:hover {
   cursor: pointer;
}

.sort-option:hover {
   cursor: pointer;
}

.cloud-td-one-share {
    width: 40%;
    cursor: pointer;
    height: 40Px;/*no*/
}

.cloud-td-one-share:hover {
    cursor: pointer;
}

.cloud-td-two {
    width: 15%;
    text-align: left;
    cursor: pointer;
    line-height: 40px;/*no*/
}

.cloud-td-two:hover {
    cursor: pointer;
}

.tr-check-box {
    width: 55px;
    /*no*/
    height: 40px;
    /*no*/
    float: left;
    position: relative;
}



.refresh-position {
    margin-left: 10px;
    /*no*/
    float: right;
}
/*右上角列表格式切换相关css*/

.share-icons .list:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 30px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 600;
    white-space: nowrap;
}

.share-icons .grid:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 30px;
    /*no*/
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 3;
}


.grid-edit-input {
    float: left;
    width: 70px;
    /*no*/
    height: 100%;
    margin: 0px;
    /*no*/
    padding-left: 1px;
    /*no*/
    border: none !important;
    color: #6f7886;
}
.share-icons .cloud-exploer-refresh:hover:after {
    content: attr(data-title);
    position: fixed;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    position: absolute;
    top: 30px;
    /*no*/
    left: 30%;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 600;
    white-space: nowrap;

}

.menu-txt {
    float: left;
}

.tr-back-ground {
  background: #ebf3fe!important;
}

#shareList .more-items-choose{
  width: 150px;/*no*/
}

.button-center-position {
    position: absolute;
    margin: auto;
    top: 5Px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow:hidden;
}

.button-content {
    vertical-align: middle;
    height: 30Px;
    width: 100%;
}
.more-botton-css{
    background-color: #5166BD;
    color: #fff;
    cursor: pointer;
    border-left: 1Px solid #ced7e5;
}
.more-botton-css:hover {
    background-color: #3250c9;
}

.more-botton-css:active {
    background-color: #5166BD;
}

.share-operating{
    position: relative;
    float: left;
    line-height: 22Px;/*no*/
}

.share-all .my-share:hover {
    cursor: pointer;
}

.share-all .save-shares:hover {
    cursor: pointer;
}

.no-manage-share {
    font-size: 14px;/*no*/
    top: 0px;
    bottom: 0;
    height: 14px;/*no*/
    margin: auto;
    margin-top: 10px;/*no*/
    float: left;
}

#shareList::-webkit-scrollbar,
.grid-list::-webkit-scrollbar,
#shareBox::-webkit-scrollbar,
.share-body::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 10Px;
    /* 给滚动条一个最小的高度 */
    background-color: #fff;
}

#shareList::-webkit-scrollbar-thumb,
.grid-list::-webkit-scrollbar-thumb,
#shareBox::-webkit-scrollbar-thumb,
.share-body::-webkit-scrollbar-thumb {
    min-height: 40px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

#fileGrid {
  overflow: auto;
}

#shareList .more-white-position {
  position: relative !important;
  top: 4Px !important;/*no*/
  margin-right: 5Px !important;/*no*/
}

#shareList .preview-position {
  position: relative !important;
    top: 8Px !important;
    margin-right: 18Px !important;
}

#shareList .th-span {
  position: relative;
  line-height: 40px;/*no*/
}

.grid-icon-positon {
    position: relative;
    top: 7px;/*no*/
    left: 8px;/*no*/
    float: left;
    width: 15Px;/*no*/
    height: 15Px;/*no*/
}

.cloud-td-title {
  float: left;
}

#shareList .list-null {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
}

#shareList .list-null div{
  text-align: center;
  line-height: 14px;/*no*/
}

#shareList .list-null .list-null-title{
  font-size: 22px;/*no*/
}

#shareList .list-null .list-null-tips{
  font-size: 14px;/*no*/
}


/* 按钮hover效果 */
#shareList .single-button:hover .cancel{
    width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    background-image: url("../../assets/images/vectorImg/icon_Cancel.svg");
    filter: drop-shadow(#fff 80px 0);/*no*/
    transform: translateX(-80px);/*no*/
}
#shareList .single-button:hover .edit-share{
    background-image: url("../../assets/images/vectorImg/icon_Edit_Share.svg");
     width: 12px;
    /*no*/
    height: 12px;
    /*no*/
    filter: drop-shadow(#fff 80px 0);/*no*/
    transform: translateX(-80px);/*no*/
}
#shareList .single-button:hover .down-load{
    background-image: url("../../assets/images/vectorImg/icon_download_white.svg");
}
#shareList .single-button:hover .preview{
    background-image: url("../../assets/images/vectorImg/icon_Preview_white.svg");
}
#shareList .single-button:hover .copy-to{
    background-image: url("../../assets/images/vectorImg/icon_Copy_to_white.svg");
}

#shareList .single-button:hover .more{
    background-image: url("../../assets/images/vectorImg/icon_moreWhite.svg");
}
#shareList .single-button:hover .remove{
    filter: drop-shadow(#fff 80px 0);/*no*/
    transform: translateX(-80px);/*no*/
}
#shareList .single-button:hover .copy{
    background-image: url("../../assets/images/vectorImg/icon_Copy_white.svg");
}
#shareList .single-button:hover .copy-link{
    filter: drop-shadow(#fff 80px 0);/*no*/
    transform: translateX(-80px);/*no*/
}
#shareList .button-border-all{
    border-right: 1Px solid #ced7e5;
    border-left: 1Px solid #ced7e5;
}

#shareList .button-border:hover::before {
  width: 0;
}

#shareList .grid-list {
  padding-left: 0px;
}

#shareList .more-item-choose {
    white-space: nowrap;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/shares.vue